var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCruiseShip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8231,
    stopColor: "#0590fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182fc"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 337.157,
    y2: 557.013
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0182fc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.484,
    x2: 277.809,
    xlinkHref: "#lg2",
    y1: 417.474,
    y2: 165.459
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.23,
    x2: 271.204,
    xlinkHref: "#lg2",
    y1: 450.977,
    y2: 274.011
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 453.827,
    y2: 508.972
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 437.888,
    x2: 457.812,
    xlinkHref: "#lg1",
    y1: 270.536,
    y2: 290.461
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.158,
    x2: 75.907,
    xlinkHref: "#lg1",
    y1: 252.152,
    y2: 276.901
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 469.314,
    x2: 488.478,
    xlinkHref: "#lg1",
    y1: 231.182,
    y2: 250.346
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 482.806,
    x2: 493.851,
    xlinkHref: "#lg1",
    y1: 280.661,
    y2: 291.706
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.158,
    x2: 79.158,
    xlinkHref: "#lg1",
    y1: 291.152,
    y2: 302.152
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.83,
    x2: 254.83,
    xlinkHref: "#lg2",
    y1: 386,
    y2: 305.723
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 224,
    x2: 299.313,
    xlinkHref: "#lg3",
    y1: 153.627,
    y2: 153.627
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ca1b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#537983"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.78,
    x2: 276.757,
    xlinkHref: "#lg4",
    y1: 29,
    y2: 29
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe646f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2b3a"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 224,
    x2: 299.313,
    xlinkHref: "#lg5",
    y1: 153.627,
    y2: 153.627
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 224,
    x2: 299.313,
    xlinkHref: "#lg3",
    y1: 100.462,
    y2: 100.462
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.667,
    x2: 112.722,
    xlinkHref: "#lg4",
    y1: 238.671,
    y2: 238.671
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 135.385,
    x2: 151.44,
    xlinkHref: "#lg4",
    y1: 218.004,
    y2: 218.004
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.103,
    x2: 190.159,
    xlinkHref: "#lg4",
    y1: 190.264,
    y2: 190.264
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.321,
    x2: 225.377,
    xlinkHref: "#lg4",
    y1: 162.651,
    y2: 162.651
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.667,
    x2: 262.722,
    xlinkHref: "#lg4",
    y1: 132.961,
    y2: 132.961
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 396.667,
    x2: 412.722,
    xlinkHref: "#lg4",
    y1: 238.671,
    y2: 238.671
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 357.949,
    x2: 374.004,
    xlinkHref: "#lg4",
    y1: 218.004,
    y2: 218.004
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.23,
    x2: 335.286,
    xlinkHref: "#lg4",
    y1: 190.264,
    y2: 190.264
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.012,
    x2: 300.068,
    xlinkHref: "#lg4",
    y1: 162.651,
    y2: 162.651
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.57,
    x2: 324.818,
    xlinkHref: "#lg3",
    y1: 156.57,
    y2: 351.316
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.936,
    x2: 319.973,
    y1: 103.219,
    y2: 284.651
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 340.543,
    x2: 205.876,
    y1: 265.961,
    y2: 223.961
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2358,
    stopColor: "#e4eef8",
    stopOpacity: 0.236
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7385,
    stopColor: "#a1c3e8",
    stopOpacity: 0.739
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7bacdf"
  }))), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.882,
    x2: 318.407,
    xlinkHref: "#lg5",
    y1: 184.813,
    y2: 361.699
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.466,
    x2: 242.132,
    y1: 253.872,
    y2: 193.205
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m462.111 316.684c-9.591 5.962-21.716 6.041-31.384.204l-16.493-9.958c-19.567-11.814-44.076-11.784-63.614.079l-.846.513c-19.373 11.762-43.731 11.564-62.91-.512-19.601-11.835-44.146-11.835-63.747.001-19.601 11.836-44.146 11.836-63.747.001l-.002-.001c-20.072-11.621-44.878-11.392-64.733.596l-14.688 8.868c-9.963 6.016-22.44 6.016-32.403 0-20.888-12.614-47.544 2.428-47.544 26.831v146.294c0 11.267 9.133 20.4 20.4 20.4h469.2c11.267 0 20.4-9.133 20.4-20.4v-146.297c0-24.583-27.011-39.597-47.889-26.619z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.889 354.332c9.591 5.962 21.716 6.041 31.384.204l16.493-9.958c19.567-11.814 44.076-11.784 63.614.079l.846.513c19.373 11.762 43.731 11.564 62.91-.512 19.601-11.835 44.146-11.835 63.747.001 19.601 11.836 44.146 11.836 63.747.001l.003-.001c20.072-11.621 44.878-11.392 64.733.596l14.688 8.868c9.963 6.016 22.44 6.016 32.403 0 20.89-12.614 47.545 2.429 47.545 26.831v108.646c0 11.267-9.133 20.4-20.4 20.4h-469.202c-11.267 0-20.4-9.133-20.4-20.4v-108.649c0-24.583 27.011-39.597 47.889-26.619z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.889 415.332c9.591 5.962 21.716 6.041 31.384.204l16.493-9.958c19.567-11.814 44.076-11.784 63.614.079l.846.513c19.373 11.762 43.731 11.564 62.91-.512 19.601-11.835 44.146-11.835 63.747.001 19.601 11.836 44.146 11.836 63.747.001l.003-.001c20.072-11.621 44.878-11.392 64.733.596l14.688 8.868c9.963 6.016 22.44 6.016 32.403 0 20.89-12.614 47.545 2.429 47.545 26.831v47.646c0 11.267-9.133 20.4-20.4 20.4h-469.202c-11.267 0-20.4-9.133-20.4-20.4v-47.649c0-24.583 27.011-39.597 47.889-26.619z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 417.827v71.773c0 11.267 9.133 20.4 20.4 20.4h469.2c11.267 0 20.4-9.133 20.4-20.4v-71.773z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m474.47 276.354c0-6.435-4.364-12.738-10.999-13.681-33.983-4.83-39.899 33.033-33.203 36.932 6.695 3.895 9.661-13.245 27.146-9.544 8.598 1.82 15.05-3.103 16.723-10.664.226-1.021.333-2.04.333-3.043z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.416,
    cy: 259.41,
    fill: "url(#SVGID_6_)",
    r: 17.666
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.572,
    cy: 240.44,
    fill: "url(#SVGID_7_)",
    r: 16.252
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 488.814,
    cy: 286.668,
    fill: "url(#SVGID_8_)",
    r: 10.242
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.916,
    cy: 296.91,
    fill: "url(#SVGID_9_)",
    r: 10.242
  })), /*#__PURE__*/React.createElement("path", {
    d: "m385.17 336.17-61.26 61.26h-137.82l-61.6-61.61c12.03-.6 24.2 2.35 34.89 8.84l.85.51c19.37 11.76 43.73 11.56 62.91-.51 9.8-5.92 20.84-8.88 31.87-8.88s22.07 2.96 31.87 8.88 20.84 8.88 31.88 8.88 22.07-2.96 31.87-8.88c9.86-5.71 20.87-8.56 31.86-8.56.89 0 1.78.02 2.68.07z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m331.064 259.927h-152.128v-172.571c0-15.14 9.999-28.46 24.536-32.688 33.654-9.787 69.4-9.787 103.055 0 14.538 4.228 24.536 17.548 24.536 32.688v172.571z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.345 58h-74.691v-38.347c0-7.433 4.909-13.973 12.047-16.049 16.524-4.805 34.074-4.805 50.597 0 7.138 2.076 12.047 8.616 12.047 16.049z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.064 259.927h-152.128v-137.545l2-16.951-2-11.884v-6.191c0-15.14 9.999-28.46 24.536-32.688 33.654-9.787 69.4-9.787 103.055 0 14.538 4.228 24.536 17.548 24.536 32.688v6.191l-2 11.134 2 17.701v137.545z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.064 93.547c-3.702-2.593-7.865-4.619-12.383-5.933-41.592-12.096-85.768-12.096-127.36 0-4.519 1.314-8.682 3.34-12.383 5.933v28.834c3.702-2.593 7.865-4.619 12.383-5.933 41.592-12.096 85.768-12.096 127.36 0 4.519 1.314 8.682 3.34 12.383 5.933z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m105 259.337c-3.866 0-7-3.134-7-7v-27.333c0-3.866 3.134-7 7-7 3.866 0 7 3.134 7 7v27.333c0 3.866-3.134 7-7 7z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.718 238.671c-3.866 0-7-3.134-7-7v-27.333c0-3.866 3.134-7 7-7 3.866 0 7 3.134 7 7v27.333c0 3.866-3.134 7-7 7z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.436 210.931c-3.866 0-7-3.134-7-7v-27.333c0-3.866 3.134-7 7-7 3.866 0 7 3.134 7 7v27.333c0 3.866-3.134 7-7 7z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.655 183.318c-3.866 0-7-3.134-7-7v-27.333c0-3.866 3.134-7 7-7 3.866 0 7 3.134 7 7v27.333c0 3.866-3.134 7-7 7z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 153.627c-3.866 0-7-3.134-7-7v-27.333c0-3.866 3.134-7 7-7 3.866 0 7 3.134 7 7v27.333c0 3.866-3.134 7-7 7z",
    fill: "url(#SVGID_19_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m405 259.337c-3.866 0-7-3.134-7-7v-27.333c0-3.866 3.134-7 7-7 3.866 0 7 3.134 7 7v27.333c0 3.866-3.134 7-7 7z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.282 238.671c-3.866 0-7-3.134-7-7v-27.333c0-3.866 3.134-7 7-7 3.866 0 7 3.134 7 7v27.333c0 3.866-3.134 7-7 7z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.564 210.931c-3.866 0-7-3.134-7-7v-27.333c0-3.866 3.134-7 7-7 3.866 0 7 3.134 7 7v27.333c0 3.866-3.134 7-7 7z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.345 183.318c-3.866 0-7-3.134-7-7v-27.333c0-3.866 3.134-7 7-7 3.866 0 7 3.134 7 7v27.333c0 3.866-3.134 7-7 7z",
    fill: "url(#SVGID_23_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m414.71 306.62-29.54 29.55c-.9-.05-1.79-.07-2.68-.07-10.99 0-22 2.85-31.86 8.56-9.8 5.92-20.83 8.88-31.87 8.88s-22.08-2.96-31.88-8.88-20.84-8.88-31.87-8.88-22.07 2.96-31.87 8.88c-19.18 12.07-43.54 12.27-62.91.51l-.85-.51c-10.69-6.49-22.86-9.44-34.89-8.84l-29.2-29.2c-17.53-17.52-12.71-47.08 9.49-58.1 39.85-19.77 95.97-52.87 130.52-95.89 10.1-12.59 29.3-12.59 39.4 0 34.55 43.02 90.67 76.12 130.52 95.89 22.2 11.02 27.02 40.58 9.49 58.1z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.782 230.025c39.848-19.772 95.97-52.869 130.514-95.894 10.104-12.585 29.303-12.585 39.407 0 34.544 43.024 90.667 76.122 130.515 95.894.078.038.155.077.232.116 10.051 5.074 20.927-5.515 15.685-15.479-3.373-6.411-8.734-11.917-15.917-15.481-39.848-19.772-95.97-52.869-130.515-95.894-10.104-12.585-29.303-12.585-39.407 0-34.544 43.024-90.667 76.122-130.514 95.894-7.184 3.564-12.545 9.07-15.918 15.481-5.242 9.964 5.635 20.552 15.685 15.479.078-.039.155-.077.233-.116z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.71 306.62-29.54 29.55c-.9-.05-1.79-.07-2.68-.07-10.99 0-22 2.85-31.86 8.56-9.8 5.92-20.83 8.88-31.87 8.88s-22.08-2.96-31.88-8.88-20.84-8.88-31.87-8.88h-.01v-192.59c7.32 0 14.65 3.14 19.7 9.44 34.55 43.02 90.67 76.12 130.52 95.89 22.2 11.02 27.02 40.58 9.49 58.1z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.711 306.623c2.877-2.877 5.14-6.082 6.834-9.472-3.343-5.657-8.843-10.535-16.327-13.644-48.868-20.299-122.214-57.374-150.218-105.978-28.004 48.605-101.35 85.68-150.218 105.978-7.485 3.109-12.985 7.986-16.327 13.644 1.695 3.39 3.957 6.595 6.834 9.472l19.684 19.684c48.357-19.142 113.91-51.293 140.028-92.58 26.117 41.287 91.671 73.438 140.028 92.58z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.028 326.306 19.684-19.684c2.877-2.877 5.14-6.082 6.834-9.472-3.343-5.657-8.843-10.535-16.327-13.644-48.869-20.298-122.215-57.373-150.219-105.977v56.198c26.117 41.287 91.671 73.437 140.028 92.579z",
    fill: "url(#SVGID_28_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCruiseShip);
export default __webpack_public_path__ + "static/media/icon-cruise-ship.94d78d4631622c83e0c7e6f6a898587a.svg";
export { ForwardRef as ReactComponent };